import axios from 'axios';

const API_URL = process.env.REACT_APP_BASEURL + 'nos';

export const getAllNOS = (params: { search?: string; limit?: number; skip?: number }) => {
  return axios.get(`${API_URL}/all`, { params });
};

export const createNOS = (payload: any) => {
  return axios.post(`${API_URL}/add`, payload);
};

export const updateNOS = (nosId: string, payload: any) => {
  return axios.put(`${API_URL}`, {
    nosId,
    ...payload
  });
};

export const deleteNOS = (nosId: string) => {
  return axios.delete(`${API_URL}`, {
    params: { nosId }
  });
};

/** Create a new NOS version from an existing one (existing QPs keep using the old version). */
export const createNewNOSVersion = (nosId: string, overrides?: { nosName?: string; pcIds?: string[] }) => {
  return axios.post(`${API_URL}/new-version`, { nosId, ...overrides });
};
